export const serviceLocationCodes = [
    {
        id: 5,
        name: "Parking",
        code: "parking"
    },
    {
        id: 6,
        name: "Toilet",
        code: "toilet"
    },
    {
        id: 7,
        name: "Elevator",
        code: "elevator"
    },
    {
        id: 8,
        name: "ATM",
        code: "atm"
    },
    {
        id: 9,
        name: "Escalator",
        code: "escalator"
    },
    {
        id: 10,
        name: "Stairs",
        code: "stairs"
    },
    {
        id: 11,
        name: "Taxi",
        code: "taxi"
    },
    {
        id: 12,
        name: "Recycling",
        code: "recycling"
    },
    {
        id: 13,
        name: "Train",
        code: "train"
    },
    {
        id: 14,
        name: "Metro",
        code: "metro"
    },
    {
        id: 15,
        name: "Tram",
        code: "tram"
    },
    {
        id: 16,
        name: "Bus",
        code: "bus"
    },
    {
        id: 17,
        name: "Stop",
        code: "stop"
    },
    {
        id: 18,
        name: "Nursery room",
        code: "nursery_room"
    },
    {
        id: 20,
        name: "Service desk",
        code: "service_desk"
    },
    {
        id: 21,
        name: "Directory",
        code: "directory"
    },
    {
        id: 22,
        name: "Accessible WC",
        code: "accessible_wc"
    },
    {
        id: 23,
        name: "Bottle recycling",
        code: "bottle_recycling"
    },
    {
        id: 24,
        name: "Playground",
        code: "playground"
    },
];